import ApiClient from '../../../helpers/apiClient';
import { startSubmit } from 'redux-form';

export const FETCH_CITY_OPTION_REQUEST = 'FETCH_CITY_OPTION_REQUEST';
export const FETCH_CITY_OPTION_SUCCESS = 'FETCH_CITY_OPTION_SUCCESS';
export const FETCH_CITY_OPTION_ERROR = 'FETCH_CITY_OPTION_ERROR';

export const FETCH_COUNTRY_OPTION_REQUEST = 'FETCH_COUNTRY_OPTION_REQUEST';
export const FETCH_COUNTRY_OPTION_SUCCESS = 'FETCH_COUNTRY_OPTION_SUCCESS';
export const FETCH_COUNTRY_OPTION_ERROR = 'FETCH_COUNTRY_OPTION_ERROR';

export const FETCH_PROVINCE_OPTION_REQUEST = 'FETCH_PROVINCE_OPTION_REQUEST';
export const FETCH_PROVINCE_OPTION_SUCCESS = 'FETCH_PROVINCE_OPTION_SUCCESS';
export const FETCH_PROVINCE_OPTION_ERROR = 'FETCH_PROVINCE_OPTION_ERROR';

export const fetchCityOptions = (provinceId) => dispatch => {
  return Promise.resolve().then(() =>
    dispatch({
      types: [FETCH_CITY_OPTION_REQUEST, FETCH_CITY_OPTION_SUCCESS, FETCH_CITY_OPTION_ERROR],
      callAPI: () => ApiClient.get(`network/City/GetSelectList?provinceId=${provinceId}`),
      payload: {},
    }),
  );
};

export const fetchCityOptionsByProvinceName = (provinceName) => dispatch => {
  return Promise.resolve().then(() =>
    dispatch({
      types: [FETCH_CITY_OPTION_REQUEST, FETCH_CITY_OPTION_SUCCESS, FETCH_CITY_OPTION_ERROR],
      callAPI: () => ApiClient.get(`network/City/GetSelectListByProvinceName?provinceName=${provinceName}`),
      payload: {},
    }),
  );
};

export const  fetchCountryOptions = () => dispatch => {
  return Promise.resolve().then(() =>
    dispatch({
      types: [FETCH_COUNTRY_OPTION_REQUEST, FETCH_COUNTRY_OPTION_SUCCESS, FETCH_COUNTRY_OPTION_ERROR],
      callAPI: () => ApiClient.get('network/country/GetSelectList'),
      payload: {},
    }),
  );
};

export const  fetchProvinceOptions = (countryId) => dispatch => {
  return Promise.resolve().then(() =>
    dispatch({
      types: [FETCH_PROVINCE_OPTION_REQUEST, FETCH_PROVINCE_OPTION_SUCCESS, FETCH_PROVINCE_OPTION_ERROR],
      callAPI: () => ApiClient.get(`network/Province/GetSelectList?countryid=${countryId}`),
      payload: {},
    }),
  );
};

export const  fetchProvinceOptionsByCountryName = (countryName) => dispatch => {
  return Promise.resolve().then(() =>
    dispatch({
      types: [FETCH_PROVINCE_OPTION_REQUEST, FETCH_PROVINCE_OPTION_SUCCESS, FETCH_PROVINCE_OPTION_ERROR],
      callAPI: () => ApiClient.get(`network/Province/GetSelectListByCountryName?countryName=${countryName}`),
      payload: {},
    }),
  );
};

export const  fetchDefaultStateOptions = () => dispatch => {
  return Promise.resolve().then(() =>
    dispatch({
      types: [FETCH_PROVINCE_OPTION_REQUEST, FETCH_PROVINCE_OPTION_SUCCESS, FETCH_PROVINCE_OPTION_ERROR],
      callAPI: () => ApiClient.get(`network/Province/GetDefaultSelectList`),
      payload: {},
    }),
  );
};

  const initialState = {
    payload: {},
    data: {},
    response: {},
    error: {},
    errorMessage: '',
    successMessage: '',
  };
  
  export default function reducer(state = initialState, action) {
    const { payload, response, error, successMessage, errorMessage } = action;
    switch (action.type) {
      case FETCH_CITY_OPTION_REQUEST:
      case FETCH_COUNTRY_OPTION_REQUEST:
      case FETCH_PROVINCE_OPTION_REQUEST:
        return {
          ...state,
          payload,
          response: {},
          error: {},
          successMessage: '',
          errorMessage: '',
        };
  
      case FETCH_CITY_OPTION_SUCCESS:
        return {
          ...state,
          data: { ...state.data, cityOptions: response.data.data },
          response,
          successMessage,
        };

      case FETCH_COUNTRY_OPTION_SUCCESS:
        return {
          ...state,
          data: { ...state.data, countryOptions: response.data.data },
          response,
          successMessage,
        };

      case FETCH_PROVINCE_OPTION_SUCCESS:
        return {
          ...state,
          data: { ...state.data, provinceOptions: response.data.data },
          response,
          successMessage,
        };
    
      case FETCH_CITY_OPTION_ERROR:
      case FETCH_COUNTRY_OPTION_ERROR:
      case FETCH_PROVINCE_OPTION_ERROR:
        return {
          ...state,
          payload,
          error,
          errorMessage,
        };
      default:
        return state;
    }
  }